import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

    width: 100%;
    height: 500px;

    @media (max-width: 900px) {
        height: 400px;
    }
`;

export const Content = styled.div`
    max-width: 100%;
    max-height: 500px;

    @media (max-width: 900px) {
        height: 400px;
        /* max-width: 50%; */
    }
`;

export const Button = styled.button`
    display: flex;
    align-items: center;
    padding: 4px 8px;
    background-color: ${(props) => props.theme.colors.white};
    color: ${(props) => props.theme.colors.gray.gray_500};
    border: 1px solid ${(props) => props.theme.colors.gray.gray_100};
    border-radius: 4px;
    
    &:hover{
        background-color: ${(props) => props.theme.colors.gray.gray_100};
        color: ${(props) => props.theme.colors.gray.gray_800};
    }
`;

export const Image = styled.img`
    max-width: 100%;
    height: auto;
    max-height: 400px;
    border-radius: 8px;

    background-color: red;

    @media (max-width: 900px) {
        max-height: 200px;
        max-width: 200px;
    }
`;

export const ContentPdf = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    height: 100%;
`;

export const Frame = styled.iframe`
    background-color: azure;

    width: 100%;
    height: auto;
    max-height: 50px;
    
    @media (max-width: 900px) {
        max-height: 200px;
        max-width: 200px;
    }
`;